const certificate = () => {
    $('.certificate-accordion > li').click(e => {
        $('.certificate-shown').removeClass('certificate-shown');
        setTimeout(function () {
            $(e.target).addClass('certificate-shown');
            var i = $(e.target).index();
            i++;
            var imgSrc = $('.certificate-gallery-thumnail img:nth-child(' + i + ')').attr('src');
            $('#certificateMainImg').attr('src', imgSrc);
        },1000)
    })

    $('.certificate-gallery-thumnail img').click(e => {
        var i = $(e.target).index();
        i++;
        var imgSrc = $(e.target).attr('src');
        $('.certificate-shown').removeClass('certificate-shown');
        setTimeout(function () {
            $('#certificateMainImg').attr('src', imgSrc);
            $('.certificate-accordion > li:nth-child(' + i + ')').addClass('certificate-shown');
        },1000)
        
    })
};

export {
    certificate
};
